export function formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
  
  export function parseTime(timeString: string): number {
    const [minutes, seconds] = timeString.split(':').map(Number);
    return minutes * 60 + seconds;
  }
  
  export function validateTimeRange(
    startTime: number,
    endTime: number,
    duration: number
  ): { isValid: boolean; message?: string } {
    if (startTime < 0) {
      return { 
        isValid: false, 
        message: 'Start time cannot be negative' 
      };
    }
  
    if (startTime >= endTime) {
      return { 
        isValid: false, 
        message: 'End time must be after start time' 
      };
    }
  
    if (endTime > duration) {
      return { 
        isValid: false, 
        message: 'End time cannot exceed video duration' 
      };
    }
  
    return { isValid: true };
  }